import React from 'react'
import PropTypes from 'prop-types'
import * as Accordion from '@radix-ui/react-accordion'
import {ChevronDownIcon} from 'lucide-react'

export const AccordionLink = ({title, links = []}) => {
    return (
        <div className="px-[4.5px]" data-testid="accordion-link-Box">
            <Accordion.Root type="single" collapsible data-testid="accordion-link-Accordion">
                <Accordion.Item
                    value="item-1"
                    className="border-0"
                    data-testid="accordion-link-AccordionItem"
                >
                    <Accordion.Trigger
                        className="flex w-full items-center justify-between py-[10px] px-0"
                        data-testid="accordion-link-AccordionButton"
                    >
                        <h2 className="text-lg font-bold" data-testid="accordion-link-Text">
                            {title}
                        </h2>
                        <ChevronDownIcon className="h-4 w-4 transition-transform duration-200 [[data-state=open]>&]:rotate-180" />
                    </Accordion.Trigger>
                    <Accordion.Content
                        className="overflow-hidden px-5 data-[state=open]:pt-[10px] data-[state=open]:mb-4"
                        data-testid="accordion-link-AccordionPanel"
                    >
                        <ul className="flex flex-col gap-8" data-testid="accordion-link-List">
                            {links.map((link, index) => (
                                <li key={index} data-testid="accordion-link-ListItem">
                                    <a href={link.href} data-testid="accordion-link-Link">
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </Accordion.Content>
                </Accordion.Item>
            </Accordion.Root>
        </div>
    )
}

export const AccordionLinkDefinition = {
    component: AccordionLink,
    name: 'AccordionLink',
    image: 'https://unpkg.com/@mdi/svg@7.4.47/svg/form-select.svg',
    inputs: [
        {
            name: 'title',
            type: 'string',
            required: true,
            helperText: 'The title of the accordion.'
        },
        {
            name: 'links',
            type: 'list',
            subFields: [
                {name: 'label', type: 'string', required: true},
                {name: 'href', type: 'url', required: true}
            ],
            helperText: 'The array of links.'
        }
    ]
}

AccordionLink.propTypes = {
    title: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })
    )
}
